import React from "react";
import { Link } from "react-router-dom";
import { MANAGEMENT_PAGES } from "../lib/managementPages";
import styles from "../styles/footer.module.css";

/**
 * Footer (v2) — ported from claude.ai/design `운영관리 PC`.
 * Editorial / monochrome / navy. Shared across the site.
 * Responsive (single breakpoint at 720px) via footer.module.css.
 */
const Footer: React.FC<any> = (props) => {
    return (
        <footer className={styles.footV2}>
            <div className={styles.footInner}>

                {/* ─── Band 1 — Contact + SNS + Nav ─── */}
                <div className={`${styles.footBand} ${styles.footBandTop}`}>
                    <div className={styles.footContact}>
                        <div className={styles.footEyebrow}>입학 문의</div>
                        <h2 className={styles.footContactTitle}>수능선배 학원</h2>
                        <p className={styles.footContactHours}>
                            상담시간 · 월~토 08:00 — 23:00<br />
                            일요일 · 카카오톡 상담 (08:00 — 23:00)
                        </p>
                        <a className={styles.footTel} href="tel:1668-5786">
                            <span className={styles.footTelLabel}>대표번호</span>
                            <span className={styles.footTelNum}>1668 — 5786</span>
                        </a>
                    </div>

                    <div className={styles.footRight}>
                        <div className={styles.footSnsBlock}>
                            <div className={styles.footSnsLabel}>공식 채널</div>
                            <ul className={styles.footSns} aria-label="SNS">
                                <li>
                                    <a
                                        href="https://blog.naver.com/bioochemistry"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="네이버 블로그"
                                    >
                                        <img src="/img/footer/naver-blog.svg" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://www.instagram.com/suneung_sunbae?igsh=MXAydndnY3Uxd3l0Yg%3D%3D"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="인스타그램"
                                    >
                                        <img src="/img/footer/instagram.svg" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://youtube.com/channel/UC9ITIVO-6xq48_utIiCIA_Q?si=3bULOi3Jp8lmGmPZ"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="유튜브"
                                    >
                                        <img src="/img/footer/youtube.svg" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a
                                        href="https://pf.kakao.com/_Whxexgxj/chat"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label="카카오 채널"
                                    >
                                        <img src="/img/footer/kakao.svg" alt="" />
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <nav className={styles.footNav} aria-label="Footer">
                            <div className={styles.footNavCol}>
                                <h3 className={styles.footNavTitle}>관리 시스템</h3>
                                <ul className={styles.footNavList}>
                                    {MANAGEMENT_PAGES.map((p) => (
                                        <li key={p.key}><Link to={`/operationmanagement?m=${p.key}`}>{p.label}</Link></li>
                                    ))}
                                </ul>
                            </div>
                            <div className={styles.footNavCol}>
                                <h3 className={styles.footNavTitle}>학원</h3>
                                <ul className={styles.footNavList}>
                                    <li><Link to="/ceo">학원소개</Link></li>
                                    <li><Link to="/teachers">담임멘토</Link></li>
                                    <li><Link to="/review">합격 후기</Link></li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>

                {/* ─── Band 2 — Brand + Legal ─── */}
                <div className={`${styles.footBand} ${styles.footBandMid}`}>
                    <div className={styles.footBrand}>
                        <img
                            src="/img/footer/sunbae-wordmark.svg"
                            alt="수능선배"
                            className={styles.footLogo}
                        />
                        <div className={styles.footBiz}>
                            <ul className={styles.footBizRow}>
                                <li>대표 <span>고용범</span></li>
                                <li>사업자등록번호 <span>711-85-02750</span></li>
                                <li>학원등록번호 <span>제14168호 · 제8432호</span></li>
                            </ul>
                            <div className={styles.footAddr}>
                                서울특별시 송파구 백제고분로 401, 4층 · <Link to="/mapmain">오시는 길</Link>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ─── Band 3 — Copyright ─── */}
                <div className={`${styles.footBand} ${styles.footBandBot}`}>
                    <div className={styles.footCopy}>© 2026 SUNUNG SUNBAE. All rights reserved.</div>
                </div>

            </div>
        </footer>
    );
};

export default Footer;
